import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Insert2"
});
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createStaticVNode('<path d="M3 1.5V4.5H4.5V6H1.5V1.5H3Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 9C2.25 8.58579 2.58579 8.25 3 8.25H21C21.4142 8.25 21.75 8.58579 21.75 9V15C21.75 15.4142 21.4142 15.75 21 15.75H3C2.58579 15.75 2.25 15.4142 2.25 15V9ZM3.75 9.75V14.25H20.25V9.75H3.75Z"></path><path d="M22.5 1.5H21V4.5H19.5V6L22.5 6V1.5Z"></path><path d="M10.5 4.5H7.5V6H10.5V4.5Z"></path><path d="M13.5 4.5L16.5 4.5V6L13.5 6V4.5Z"></path><path d="M21 22.5V19.5L19.5 19.5V18H22.5V22.5H21Z"></path><path d="M1.5 22.5H3L3 19.5L4.5 19.5V18L1.5 18V22.5Z"></path><path d="M13.5 19.5H16.5V18H13.5V19.5Z"></path><path d="M10.5 19.5H7.5L7.5 18H10.5L10.5 19.5Z"></path>', 9);
const _hoisted_11 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_11);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Insert2.vue"]]);
